import { SET_RCT_ACCURACY_CONTENT } from './rctActions';

export const defaultState = {
    isDataFetched: false,
    model: [{
        stimulus: { stimulusAudio: '' },
        possibleResponses: [],
    }],
    practice: [{
        stimulus: { stimulusAudio: '' },
        possibleResponses: [],
    }],
    questions: [],
    questionsCount: 0,
};

/**
 * Reformat single RCT Accuracy question item from api call from
 * snake_case to camelCase
 * @param {Object} apiItemContent
 * @returns {Object}
 */
const reformatItemContent = (apiItemContent) => ({
    possibleResponses: apiItemContent.possible_responses.map((possibleResponse) => ({
        id: possibleResponse.response_id,
        text: possibleResponse.response_text,
    })),
    stimulus: {
        stimulusAudio: apiItemContent.stimulus.stimulus_audio,
    },
});

/**
 * Reformat content retrieved from API (snake_case)
 * to the content format we need in front end (camelCase)
 * @param {Object} apiContent
 * @returns {Object}
 */
export const reformatAccuracyContent = (apiContent) => ({
    correctResponses: apiContent.correct_responses,
    formId: apiContent.form_id,
    grade: apiContent.grade,
    measure: apiContent.measure,
    measureType: apiContent.measure_type,
    period: apiContent.period,
    model: apiContent.model.map((modelItemContent) => ({
        ...reformatItemContent(modelItemContent),
        correctResponse: {
            id: modelItemContent.correct_response.id,
        },
    })),
    practice: apiContent.practice.map((practiceItemContent) => ({
        ...reformatItemContent(practiceItemContent),
        correctResponse: {
            id: practiceItemContent.correct_response.id,
        },
    })),
    questions: apiContent.questions.map((questionItemContent) => ({
        ...reformatItemContent(questionItemContent),
        itemId: questionItemContent.item_id,
    })),
    totalItems: {
        model: apiContent.total_items.model,
        practice: apiContent.total_items.practice,
        questions: apiContent.total_items.questions,
    },
    questionsCount: apiContent.total_items.questions,
});

const rctAccuracyReducer = (state = defaultState, action) => {
    switch (action.type) {
    case SET_RCT_ACCURACY_CONTENT:
        return {
            ...state,
            isDataFetched: true,
            ...reformatAccuracyContent(action.content),
        };
    default:
        return state;
    }
};

export default rctAccuracyReducer;
